export default {"src":"/_next/static/media/stage.1d0af3cb.svg","height":443,"width":867};